import {
  coreExtensionData,
  createFrontendModule,
  OverridableExtensionDefinition,
} from '@backstage/frontend-plugin-api';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import { ComponentType, PropsWithChildren } from 'react';
import {
  EntityTechDocsAvailability,
  TechDocsReaderAvailability,
} from './TechDocsAvailability';

function wrapElement(
  extension: OverridableExtensionDefinition,
  Wrapper: ComponentType<PropsWithChildren<{}>>,
) {
  return extension.override({
    factory(originalFactory) {
      const output = originalFactory();
      return [
        ...Array.from(output).filter(
          value => value.id !== coreExtensionData.reactElement.id,
        ),
        coreExtensionData.reactElement(
          <Wrapper>{output.get(coreExtensionData.reactElement)}</Wrapper>,
        ),
      ];
    },
  });
}

export const techdocsAvailabilityModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [
    wrapElement(
      techdocsPlugin.getExtension('page:techdocs/reader'),
      TechDocsReaderAvailability,
    ),
    wrapElement(
      techdocsPlugin.getExtension('entity-content:techdocs'),
      EntityTechDocsAvailability,
    ),
  ],
});
